import React from 'react';
import classes from './index.module.scss';
import { Row, Col } from 'react-bootstrap';

const InfoBoard = ({ children }) => {

  return (
    <div className={classes.Info_Board}>
      <Row>
        {
          React.Children.map(children, item => {
            return (
              <Col>
                {item}
              </Col>
            )
          })
        }
      </Row>
    </div>
  )
}

export default InfoBoard;